import React from "react";
import ReactDOM from "react-dom";
import {BrowserRouter} from "react-router-dom";

import * as Sentry from "@sentry/browser";

import {App} from "./App";
import {SENTRY_DSN, SENTRY_ENV} from "./config";

setTimeout(() => {
    window.location.reload();
}, 1000 * 60 * 60 * 6)

if (SENTRY_DSN) {
    Sentry.init({
        dsn: SENTRY_DSN,
        environment: SENTRY_ENV,
    });
}
ReactDOM.render(
    <BrowserRouter>
        <App/>
    </BrowserRouter>,
    document.getElementById("root")
);